import React from 'react';
import IProps from './interface';

const NoStrategies = ({ width = '200px' }: IProps) => {
  return (
    <svg
      width={width}
      height="auto"
      viewBox="0 0 200 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7724_423166)">
        <circle cx="106.5" cy="72" r="67" fill="#F4F7FA" />
        <g clipPath="url(#clip1_7724_423166)">
          <g filter="url(#filter0_f_7724_423166)">
            <rect
              x="62.1973"
              y="50.3594"
              width="121"
              height="81"
              rx="8"
              transform="rotate(-5.83338 62.1973 50.3594)"
              fill="#3E485B"
              fillOpacity="0.1"
            />
          </g>
          <g filter="url(#filter1_f_7724_423166)">
            <rect
              x="28.1494"
              y="-0.408203"
              width="119.387"
              height="70.2253"
              rx="8"
              transform="rotate(13.7241 28.1494 -0.408203)"
              fill="#3E485B"
              fillOpacity="0.1"
            />
          </g>
        </g>
        <g filter="url(#filter2_d_7724_423166)">
          <rect
            x="33.1597"
            width="107.338"
            height="62.5532"
            rx="8"
            transform="rotate(12.1445 33.1597 0)"
            fill="white"
          />
          <rect
            x="33.5433"
            y="0.593999"
            width="106.338"
            height="61.5532"
            rx="7.5"
            transform="rotate(12.1445 33.5433 0.593999)"
            stroke="url(#paint0_linear_7724_423166)"
          />
        </g>
        <rect
          opacity="0.7"
          x="41.4209"
          y="15.4883"
          width="44.3048"
          height="6.70213"
          rx="3.35106"
          transform="rotate(12.1445 41.4209 15.4883)"
          fill="#E0E7F1"
        />
        <rect
          opacity="0.7"
          x="37.1147"
          y="32.4883"
          width="77.7515"
          height="4.46809"
          rx="2.23404"
          transform="rotate(12.1445 37.1147 32.4883)"
          fill="#F5F7F9"
        />
        <rect
          opacity="0.7"
          x="33.9399"
          y="46"
          width="77.7515"
          height="4.46809"
          rx="2.23404"
          transform="rotate(12.1445 33.9399 46)"
          fill="#F5F7F9"
        />
        <rect
          x="83.6689"
          y="52.002"
          width="31.2766"
          height="4.46809"
          rx="2.23404"
          transform="rotate(12.1445 83.6689 52.002)"
          fill="#F5F7F9"
        />
        <g filter="url(#filter3_d_7724_423166)">
          <rect
            x="65"
            y="52.5684"
            width="118.964"
            height="70.8724"
            rx="9.06396"
            transform="rotate(-6.06479 65 52.5684)"
            fill="white"
          />
          <rect
            x="65.6232"
            y="53.0718"
            width="117.831"
            height="69.7394"
            rx="8.49746"
            transform="rotate(-6.06479 65.6232 53.0718)"
            stroke="url(#paint1_linear_7724_423166)"
            strokeWidth="1.13299"
          />
        </g>
        <rect
          x="79.2725"
          y="65.4316"
          width="50.0597"
          height="7.59347"
          rx="3.79674"
          transform="rotate(-6.06479 79.2725 65.4316)"
          fill="#E0E7F1"
        />
        <rect
          x="80.1636"
          y="81.916"
          width="56.1322"
          height="5.06232"
          rx="2.53116"
          transform="rotate(-6.06479 80.1636 81.916)"
          fill="#F1F4F9"
        />
        <rect
          x="82.0825"
          y="93.8926"
          width="61.6066"
          height="5.06232"
          rx="2.53116"
          transform="rotate(-6.06479 82.0825 93.8926)"
          fill="#F1F4F9"
        />
        <rect
          x="83.8301"
          y="105.793"
          width="97.063"
          height="5.06232"
          rx="2.53116"
          transform="rotate(-6.06479 83.8301 105.793)"
          fill="#F1F4F9"
        />
        <circle
          cx="160.643"
          cy="70.6426"
          r="17.8723"
          transform="rotate(-6 160.643 70.6426)"
          fill="#F1F4F9"
        />
        <path
          d="M168.627 70.2011L169.065 78.1891"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M163.481 73.1582L163.773 78.4802"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.925 76.0703L153.089 79.0658"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M158.031 72.3847L158.382 78.7751"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M164.382 66.938C165.101 67.583 165.162 68.6893 164.517 69.4092C163.872 70.129 162.766 70.1897 162.046 69.5447C161.326 68.8998 161.266 67.7934 161.91 67.0736C162.555 66.3537 163.662 66.293 164.382 66.938"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.53 62.145C170.249 62.79 170.31 63.8964 169.665 64.6162C169.02 65.336 167.914 65.3967 167.194 64.7517C166.474 64.1068 166.413 63.0004 167.058 62.2806C167.703 61.5608 168.81 61.5001 169.53 62.145"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M153.639 68.4224C154.359 69.0673 154.42 70.1737 153.775 70.8935C153.13 71.6134 152.024 71.674 151.304 71.0291C150.584 70.3841 150.523 69.2778 151.168 68.5579C151.813 67.8381 152.92 67.7774 153.639 68.4224"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M158.789 63.6314C159.509 64.2763 159.569 65.3827 158.924 66.1025C158.279 66.8223 157.173 66.883 156.453 66.2381C155.733 65.5931 155.673 64.4867 156.318 63.7669C156.963 63.0471 158.069 62.9864 158.789 63.6314"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.09 64.6376L164.489 67.0537"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.701 67.3573L159.123 65.8262"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M153.754 68.5439L156.346 66.1284"
          stroke="#BFCDE1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip2_7724_423166)">
          <path
            d="M30.7936 130.317C27.4145 119.824 27.3874 96.8248 54.3114 88.7691"
            stroke="#ED4C5E"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeDasharray="6.91 5.53"
          />
          <path
            d="M53.5449 93.3379L56.1272 88.0945L50.8838 85.5123"
            stroke="#ED4C5E"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <circle cx="107" cy="38" r="16" fill="#FD6778" />
        <path
          d="M106.965 32.2012C108.074 32.2012 108.965 32.5052 109.637 33.1132C110.32 33.7105 110.661 34.5372 110.661 35.5932C110.661 36.6385 110.325 37.4385 109.653 37.9932C108.981 38.5372 108.09 38.8092 106.981 38.8092L106.917 40.0412H104.949L104.869 37.3212H105.589C106.517 37.3212 107.232 37.1985 107.733 36.9532C108.234 36.7078 108.485 36.2598 108.485 35.6092C108.485 35.1398 108.346 34.7665 108.069 34.4892C107.802 34.2118 107.434 34.0732 106.965 34.0732C106.474 34.0732 106.09 34.2065 105.813 34.4732C105.546 34.7398 105.413 35.1078 105.413 35.5772H103.301C103.29 34.9265 103.429 34.3452 103.717 33.8332C104.005 33.3212 104.426 32.9212 104.981 32.6332C105.546 32.3452 106.208 32.2012 106.965 32.2012ZM105.925 43.8652C105.52 43.8652 105.184 43.7425 104.917 43.4972C104.661 43.2412 104.533 42.9265 104.533 42.5532C104.533 42.1798 104.661 41.8705 104.917 41.6252C105.184 41.3692 105.52 41.2412 105.925 41.2412C106.32 41.2412 106.645 41.3692 106.901 41.6252C107.157 41.8705 107.285 42.1798 107.285 42.5532C107.285 42.9265 107.157 43.2412 106.901 43.4972C106.645 43.7425 106.32 43.8652 105.925 43.8652Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_7724_423166"
          x="34.9683"
          y="10.832"
          width="183.064"
          height="147.336"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14"
            result="effect1_foregroundBlur_7724_423166"
          />
        </filter>
        <filter
          id="filter1_f_7724_423166"
          x="-14.8438"
          y="-26.7402"
          width="185.304"
          height="149.209"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14"
            result="effect1_foregroundBlur_7724_423166"
          />
        </filter>
        <filter
          id="filter2_d_7724_423166"
          x="13.502"
          y="-4.49805"
          width="135.091"
          height="100.73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7724_423166"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7724_423166"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7724_423166"
          x="56.8423"
          y="34.1083"
          width="146.634"
          height="103.892"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.26599" dy="4.53198" />
          <feGaussianBlur stdDeviation="5.66497" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7724_423166"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7724_423166"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7724_423166"
          x1="45.938"
          y1="6"
          x2="131.88"
          y2="56.1293"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFF1F7" />
          <stop offset="1" stopColor="#E7E7E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7724_423166"
          x1="79.1624"
          y1="59.3663"
          x2="175.467"
          y2="114.317"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFF1F7" />
          <stop offset="1" stopColor="#E7E7E7" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_7724_423166">
          <rect width="200" height="144" fill="white" />
        </clipPath>
        <clipPath id="clip1_7724_423166">
          <rect x="39" y="5" width="135" height="135" rx="67.5" fill="white" />
        </clipPath>
        <clipPath id="clip2_7724_423166">
          <rect
            width="43.9181"
            height="33.2002"
            fill="white"
            transform="matrix(0.958036 -0.286647 -0.286647 -0.958036 23.748 125.15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoStrategies;
